<script lang="ts">
  import { TimezoneService } from '$lib/services/subscription/TimezoneService';
  import { useInterval } from '$lib/hooks/useTimer';
  
  let timeUntilReset = $state({ hours: 0, minutes: 0 });
  
  function updateTimeUntilReset() {
    timeUntilReset = TimezoneService.getTimeUntilKSTReset();
  }
  
  // Update immediately and then every minute
  updateTimeUntilReset();
  useInterval(updateTimeUntilReset, 60000, true); // Update every minute
  
  // Use $derived for reactive value in runes mode
  const resetText = $derived(TimezoneService.formatResetTime(timeUntilReset.hours, timeUntilReset.minutes));
</script>

<div class="reset-timer">
  <span class="reset-icon">⏰</span>
  <span class="reset-text">{resetText}</span>
</div>

<style>
  .reset-timer {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: var(--text-tertiary);
  }
  
  .reset-icon {
    font-size: 12px;
  }
  
  .reset-text {
    font-weight: 400;
  }
</style>